var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{staticClass:"region"},[(this.node.attrs.lines.attributes.id)?_c('span',{staticClass:"label"},[_vm._v("Region")]):_vm._e(),_c('node-view-content',{staticClass:"content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }